<script>
    import RequestsList from "../RequestsList.svelte";
    import DealsList from "../DealsList.svelte";
    import {PAGE_ID, router, navigateTo} from "../../stores/router";
    import {requests} from "../../stores/requests";
    import {deals} from "../../stores/deals";
    import {promotions} from "../../stores/promotions";
    import {selectRequest, selectDeal, selectPromotion, app_state} from "../../stores/misc";
    import {truncateAfter} from "../../../../../../lib/utils";
    import PromotionsList from "../PromotionsList.svelte";
    import ViewNotes from "../ViewNotes.svelte";

    const MAX_NUM_ITEMS = 5;
    $: dashboard_request_arr_list = truncateAfter($requests.list, MAX_NUM_ITEMS);
    $: dashboard_deal_arr_liat = truncateAfter($deals.list, MAX_NUM_ITEMS);
    $: dashboard_promotions_arr_liat = truncateAfter($promotions.list, MAX_NUM_ITEMS);

    let notes = [];
    const loadNotesAndLogs = async () => {
        const response = await fetch(`/api/inbox/dashboard`);
        const result = await response.json();
        notes = result.notes;
    };
    $: if($router.current_page === PAGE_ID.DASHBOARD) {
        loadNotesAndLogs();
    }

    const onRequestClick = id => {
        selectRequest(id);
        navigateTo(PAGE_ID.VIEW_REQUEST, PAGE_ID.DASHBOARD);
    };
    const onDealClick = id => {
        selectDeal(id);
        navigateTo(PAGE_ID.VIEW_DEAL, PAGE_ID.DASHBOARD);
    };

    const onPromotionClick = id => {
        selectPromotion(id);
        navigateTo(PAGE_ID.VIEW_PROMOTION, PAGE_ID.DASHBOARD);
    };



    // const types = [
    //     'audio/webm;codecs="vorbis"',
    //     'audio/webm;codecs="opus"',
    //
    //     'audio/3gpp',
    //     'audio/3gp2',
    //     'audio/mp4',
    // ];

</script>


<div class="absolute top-16 right-0 bottom-0 left-0 overflow-y-auto" class:hidden={$router.current_page !== PAGE_ID.DASHBOARD}>

    <!-- Header -->
    <div class="px-4 sm:px-6 lg:px-8">

        <!-- <Breadcrumbs></Breadcrumbs>-->

        <div class="h-16 flex items-center md:justify-between">
            <div class="min-w-0 flex-1">
                <h2 class="text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight">Dashboard</h2>
            </div>
            <div class="flex flex-shrink-0 md:mt-0 md:ml-4">
                <!-- <button type="button" class="inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">Edit</button>-->
                <!-- <button type="button" class="ml-3 inline-flex items-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">Publish</button>-->
            </div>
        </div>

    </div>

    <!-- TEMP! -->
<!--    <div class="px-4 sm:px-6 lg:px-8 py-4 bg-yellow-100">-->
<!--        {#each types as type}-->
<!--            <p class="block my-2">{`${type} ?? ${MediaRecorder.isTypeSupported(type) ? 'Maybe!' : 'Nope :('}`}</p>-->
<!--        {/each}-->
<!--        <input class="pt-4" type="file" accept="audio/*" capture />-->
<!--    </div>-->


    <h2 class="my-4 text-xl font-medium text-center text-gray-700">Inbox</h2>
    <ViewNotes type="inbox" owner_id="dashboard" bind:notes></ViewNotes>
    <div class="mb-8"><!-- Spacer --></div>

    <div on:click={() => navigateTo(PAGE_ID.REQUESTS)} class="cursor-pointer flex items-center border-b-2 border-t-2 border-yellow-200 py-5 px-4 sm:px-6 lg:px-8 bg-yellow-50">
        <!-- Request pill-->
        <div class="flex inline-flex items-center px-2 py-1 rounded-full ring-1 ring-inset ring-gray-300">
            <svg class="h-5 w-5 text-yellow-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zM8.94 6.94a.75.75 0 11-1.061-1.061 3 3 0 112.871 5.026v.345a.75.75 0 01-1.5 0v-.5c0-.72.57-1.172 1.081-1.287A1.5 1.5 0 108.94 6.94zM10 15a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd" />
            </svg>
            <p class="ml-1 text-base uppercase font-normal text-gray-600">Requests</p>
        </div>
        <h3 class="ml-2 text-base font-light italic text-gray-600">Inbound (Top 5)</h3>
    </div>
    <div class="px-4 sm:px-6 lg:px-8">
        <RequestsList requests_arr_list={dashboard_request_arr_list} on:requestClicked={(e) => onRequestClick(e.detail.id)}></RequestsList>
    </div>

<!--    <div on:click={() => navigateTo(PAGE_ID.PROMOTIONS)} class="cursor-pointer flex items-center border-b-2 border-t-2 border-purple-200 py-5 px-4 sm:px-6 lg:px-8 bg-purple-50">-->
<!--         Promotion pill-->
<!--        <div class="flex inline-flex items-center px-2 py-1 rounded-full ring-1 ring-inset ring-gray-300">-->
<!--            <svg class="h-5 w-5 text-purple-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">-->
<!--                <path d="M3.505 2.365A41.369 41.369 0 019 2c1.863 0 3.697.124 5.495.365 1.247.167 2.18 1.108 2.435 2.268a4.45 4.45 0 00-.577-.069 43.141 43.141 0 00-4.706 0C9.229 4.696 7.5 6.727 7.5 8.998v2.24c0 1.413.67 2.735 1.76 3.562l-2.98 2.98A.75.75 0 015 17.25v-3.443c-.501-.048-1-.106-1.495-.172C2.033 13.438 1 12.162 1 10.72V5.28c0-1.441 1.033-2.717 2.505-2.914z" />-->
<!--                <path d="M14 6c-.762 0-1.52.02-2.271.062C10.157 6.148 9 7.472 9 8.998v2.24c0 1.519 1.147 2.839 2.71 2.935.214.013.428.024.642.034.2.009.385.09.518.224l2.35 2.35a.75.75 0 001.28-.531v-2.07c1.453-.195 2.5-1.463 2.5-2.915V8.998c0-1.526-1.157-2.85-2.729-2.936A41.645 41.645 0 0014 6z" />-->
<!--            </svg>-->
<!--            <p class="ml-1 text-base uppercase font-normal text-gray-600">Promotions</p>-->
<!--        </div>-->
<!--        <h3 class="ml-2 text-base font-light italic text-gray-600">Outbound (Top 5)</h3>-->
<!--    </div>-->
<!--    <div class="px-4 sm:px-6 lg:px-8">-->
<!--        <PromotionsList promotions_arr_list={dashboard_promotions_arr_liat} on:promotionClicked={e => onPromotionClick(e.detail.id)}></PromotionsList>-->
        <!--<li>[sending] Meal at Restaurant X [ACME Corp.] [Shortlist 80/100]</li>-->
        <!--<li>[preparing] Red Bull Cross Europe Race [ACME Corp.] [No Shortlist]</li>-->
<!--    </div>-->

    <div on:click={() => navigateTo(PAGE_ID.DEALS)} class="cursor-pointer flex items-center border-b-2 border-t-2 border-pink-200 py-5 px-4 sm:px-6 lg:px-8 bg-pink-50">
        <!-- Deal pill-->
        <div class="flex inline-flex items-center px-2 py-1 rounded-full ring-1 ring-inset ring-gray-300">
            <svg class="h-5 w-5 text-pink-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.732 6.232a2.5 2.5 0 013.536 0 .75.75 0 101.06-1.06A4 4 0 006.5 8v.165c0 .364.034.728.1 1.085h-.35a.75.75 0 000 1.5h.737a5.25 5.25 0 01-.367 3.072l-.055.123a.75.75 0 00.848 1.037l1.272-.283a3.493 3.493 0 011.604.021 4.992 4.992 0 002.422 0l.97-.242a.75.75 0 00-.363-1.456l-.971.243a3.491 3.491 0 01-1.694 0 4.992 4.992 0 00-2.258-.038c.19-.811.227-1.651.111-2.477H9.75a.75.75 0 000-1.5H8.136A4.397 4.397 0 018 8.165V8c0-.641.244-1.28.732-1.768z" clip-rule="evenodd" />
            </svg>
            <p class="ml-1 text-base uppercase font-normal text-gray-600">Deals</p>
        </div>
        <h3 class="ml-2 text-base font-light italic text-gray-600">(Top 5)</h3>
    </div>
    <div class="px-4 sm:px-6 lg:px-8">
        <DealsList deals_arr_list={dashboard_deal_arr_liat} on:dealClicked={e => onDealClick(e.detail.id)}></DealsList>
        <!-- <li>[outreach] [ACME Corp] sale of boats in Monaco - 20% commission</li>-->
        <!-- <li>[negotiating] [ACME Corp] sale of boats in Monaco - 20% commission</li>-->
    </div>

</div>


<style></style>